import { Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsOptional, IsString, ValidateNested } from 'class-validator';

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
}

export class UserRoleRepresentationDto {
  @IsString()
  id!: string;

  @IsString()
  name!: UserRole;

  @IsBoolean()
  clientRole!: boolean;

  @IsString()
  containerId!: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsBoolean()
  composite!: boolean;
}

export class UserRolesRepresentationDto {
  @ValidateNested()
  @Type(() => UserRoleRepresentationDto)
  @IsDefined()
  roles!: UserRoleRepresentationDto[];
}
